class SearchBalanceEntriesReq{

    constructor() {
  
      this.id = undefined;
      this.fromTime = undefined;
      this.toTime = undefined;
      this.fromCurrentBalance = undefined;
      this.toCurrentBalance = undefined;
      this.fromBalanceVariation = undefined;
      this.toBalanceVariation = undefined;
      this.description = undefined;
      this.userId = undefined;
      this.accountingEntryId = undefined;
      this.accountingSessionId = undefined;
      this.packageId = undefined;
      
      this.pagingParams = {
        pageNumber: undefined,
        pageSize: undefined
      }
  
      
    }
  }
  export default SearchBalanceEntriesReq;